// Vendor Libs
import {get, map} from 'lodash';

// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Config
import servicesFormConfig from '../../config/services-form-config';

const requestPasswordMiddleware = (store) => (next) => (action) => {
    const {dispatch} = store;
    next(action);
    const actions = {
        REQUEST_PASSWORD_FULFILLED: () => handleFulfilled(dispatch, action),
        REQUEST_PASSWORD_SUBMIT: () => submitRequestPassword(dispatch, action),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function submitRequestPassword(dispatch, {clientId, formName, email}) {
    const dispatchFetched = (jsonResponse) => {
        dispatch({
            type: 'REQUEST_PASSWORD_FULFILLED',
            formName,
            response:
                jsonResponse ||
                `Password reset request for ${email} has been successfully submitted. Password reset link will be emailed.`,
        });
    };
    const dispatchError = (error) => {
        dispatch({
            type: 'REQUEST_PASSWORD_REJECTED',
            error,
        });
    };
    const actionParams = {
        servicesConfig: servicesFormConfig.forgotPassword,
        dispatchFetched,
        dispatchError,
    };
    const queryParams = {
        user: clientId,
    };

    dispatch({
        type: 'REQUEST_PASSWORD',
    });

    return Promise.resolve(actionsServiceCaller(actionParams, queryParams));
}

function handleFulfilled(dispatch, {formName}) {
    const results = map(get(servicesFormConfig, [formName, 'updateServiceDataKeys'], []), (servicesDataKey) => {
        dispatch({
            type: 'SEARCH_DATA_REFRESH',
            servicesDataKey,
            actionShouldFetch: false,
            selectRecord: false,
        });
    });

    return Promise.all(results);
}

export default requestPasswordMiddleware;
